export default function ZoomIcon() {
  return (
    <svg x="0px" y="0px" viewBox="0 0 100 100" width="20px" height="20px">
      <g>
        <path d="M98.4,95.7L63.1,60.3c5.5-6.1,8.9-14.2,8.9-23.1c0-19-15.4-34.3-34.3-34.3S3.3,18.3,3.3,37.3s15.4,34.3,34.3,34.3 c8.7,0,16.6-3.2,22.6-8.5l35.4,35.4L98.4,95.7z M37.6,67.6C20.9,67.6,7.3,54,7.3,37.3c0-16.7,13.6-30.3,30.3-30.3 c16.7,0,30.3,13.6,30.3,30.3C67.9,54,54.3,67.6,37.6,67.6z"></path>
        <polygon points="39.6,19.3 35.6,19.3 35.6,35.3 19.7,35.3 19.7,39.3 35.6,39.3 35.6,55.2 39.6,55.2 39.6,39.3 55.5,39.3 55.5,35.3  39.6,35.3 	"></polygon>
      </g>
    </svg>
  )
}
